// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__tnE_u","selects":"Documents_selects__3V-Kp"};